import { createSlice } from '@reduxjs/toolkit';
import patientApi from './patientApi';

const dataSlice = createSlice({
    name: 'patient',
    initialState: {
        listData: {},
        count: [],
        patientList: [],
        patientDropdownList: [],
        loading: true,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                patientApi.endpoints.patientList.matchPending,
                (state) => {
                    state.error = null;
                }
            )
            .addMatcher(
                patientApi.endpoints.patientList.matchFulfilled,
                (state, action) => {
                    state.listData = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                patientApi.endpoints.patientList.matchRejected,
                (state, action) => {
                    state.error = action.error.message;
                }
            )
            .addMatcher(
                patientApi.endpoints.patientCount.matchPending,
                (state) => {
                    state.loading = true;
                    state.error = null;
                }
            )
            .addMatcher(
                patientApi.endpoints.patientCount.matchFulfilled,
                (state, action) => {
                    state.loading = false;
                    state.count = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                patientApi.endpoints.allPatientList.matchFulfilled,
                (state, action) => {
                    state.patientList = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                patientApi.endpoints.allPatientDropdownList.matchFulfilled,
                (state, action) => {
                    state.patientDropdownList = action.payload; // Save the new data to the state
                }
            )
            .addMatcher(
                patientApi.endpoints.patientCount.matchRejected,
                (state, action) => {
                    state.loading = false;
                    state.error = action.error.message;
                }
            );
    },
});

export default dataSlice.reducer;
